import * as React from 'react';
import { GenericField } from '@uncinc/react-drupal-core/types';

import './style.scss';

type Props = {
  synonyms: GenericField<string>[]
};

const SynonymList: React.FC<Props> = (props) => {
  const { synonyms } = props;

  return (
    <ul className="SynonymList">
      {synonyms.map((synonym) => (
        <li>{synonym.value}</li>
      ))}
    </ul>
  );
};

export default SynonymList;
